import { z } from 'zod';
// ---------------------------------------------------------------------------
// Shared record shape
// ---------------------------------------------------------------------------
export const FormFileUploadRecordSchema = z.object({
    id: z.number(),
    identifier: z.string(),
    groupId: z.number(),
    chatInstanceId: z.number().nullable(),
    status: z.number(),
    s3Key: z.string(),
    bucket: z.string(),
    fileName: z.string(),
    fileType: z.string(),
    fileSize: z.number(),
    uploadedBy: z.number(),
    createdOn: z.string(),
    lastUpdatedOn: z.string(),
});
// ---------------------------------------------------------------------------
// Queue
// ---------------------------------------------------------------------------
export const FormFileUploadQueueRequestSchema = z.object({
    chatInstanceId: z.number().nullable().optional(),
    fileName: z.string().min(1),
    fileType: z.string().min(1),
    fileSize: z.int().min(0),
});
export const FormFileUploadQueueResponseSchema = z.object({
    fileUpload: FormFileUploadRecordSchema,
});
// ---------------------------------------------------------------------------
// Start (presigned upload URL)
// ---------------------------------------------------------------------------
export const FormFileUploadStartResponseSchema = z.object({
    uploadUrl: z.string(),
    fileUpload: FormFileUploadRecordSchema,
});
// ---------------------------------------------------------------------------
// Complete / Fail
// ---------------------------------------------------------------------------
export const FormFileUploadCompleteResponseSchema = FormFileUploadRecordSchema;
// ---------------------------------------------------------------------------
// Download URL
// ---------------------------------------------------------------------------
export const FormFileUploadDownloadUrlResponseSchema = z.object({
    url: z.string(),
    fileName: z.string(),
    fileType: z.string(),
});
